import { CollabItem } from 'components/CollabItem'
import { List } from 'components/CollabItem/List/List'
import { observer } from 'mobx-react-lite'
import { computed } from 'mobx'
import { TrackedChangeProps } from './Types'
import { useDocStore } from 'stores/DocStore'
import { TrackedChangeItem } from './TrackedChangeItem/TrackedChangeItem'
import { TrackedChangeCommentItem } from './TrackedChangeCommentItem/TrackedChangeCommentItem'
import { MaybeNewReplyForm } from './NewReplyForm/NewReplyForm'
import { useRef } from 'react'

const TrackedChange = observer(({ items, inCleanupMode = false }: TrackedChangeProps) => {
  const docStore = useDocStore()
  const [trackedChange, ...comments] = items
  const isActive = computed(() => docStore.trackedChangesStore.selectedChange?.uuid === trackedChange.uuid).get()
  const isHighlighted = computed(
    () => docStore.trackedChangesStore.highlightedChange?.uuid === trackedChange.uuid,
  ).get()

  const createReplyFormInputRef = useRef<HTMLTextAreaElement>(null)
  const collapsed = docStore.trackedChangesStore.selectedChange?.uuid !== trackedChange.uuid

  /* -------------------------------------------------------------------------------------------------
   * Mouse interactions
   * -----------------------------------------------------------------------------------------------*/

  const handleClick = () => {
    if (isActive) {
      return
    }
    docStore.trackedChangesStore.select(trackedChange.uuid)
    setTimeout(() => {
      createReplyFormInputRef.current?.focus()
    }, 50)
  }

  const handleMouseOver = () => {
    if (isActive || isHighlighted) {
      return
    }
    docStore.trackedChangesStore.highlight(trackedChange.uuid)
  }

  const handleMouseLeave = () => {
    docStore.trackedChangesStore.highlight(undefined)
  }

  const handleClickOutside = () => {
    if (isActive) {
      docStore.trackedChangesStore.select(undefined)
    }
  }

  /* -----------------------------------------------------------------------------------------------*/

  return (
    <CollabItem.Root
      isActive={isActive}
      isHighlighted={isHighlighted}
      onClick={handleClick}
      onClickOutside={handleClickOutside}
      onMouseOver={handleMouseOver}
      onMouseLeave={handleMouseLeave}
    >
      <List collapsed={collapsed} onToggle={handleClickOutside} itemId={trackedChange.uuid}>
        <TrackedChangeItem
          trackedChange={trackedChange}
          inCleanupMode={inCleanupMode}
          hasReplies={comments.length > 0}
        />
        {comments.map((comment) => (
          <TrackedChangeCommentItem key={comment.id} comment={comment} inCleanupMode={inCleanupMode} />
        ))}
      </List>
      <CollabItem.ReplyForm>
        <MaybeNewReplyForm item={trackedChange} inputRef={createReplyFormInputRef} />
      </CollabItem.ReplyForm>
    </CollabItem.Root>
  )
})

export { TrackedChange }
